import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** A bordered band with a short pitch and one button (bulk, corporate or wholesale orders). */
export const schema: ComponentSchema = {
  type: 'corporate-band',
  label: 'Bulk order band',
  description: 'Text and one button, e.g. for corporate, event or wholesale orders.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Text and button' }],
  commonFields: [
    ...headingFields({ eyebrow: 'For businesses', title: 'Bulk and corporate orders' }).filter(f => f.key !== 'subtitle'),
    { key: 'text', label: 'Text', type: 'localized-text', default: 'Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery.' },
    { key: 'cta.label', label: 'Button text', type: 'localized-string', default: 'Contact us' },
    { key: 'cta.url', label: 'Button link', type: 'string', default: '/contact' },
    ...SECTION_STYLE_FIELDS,
  ],
}
